import makeApiCall from "../master/axiosIndex";

const workExecutionApis = {
  pendingWorkExecution: (params: any) =>
    makeApiCall({
      url: "/work-order/execution/pending-approvals",
      method: "get",
      params,
    }),
  closedWorkExecution: (params: any) =>
    makeApiCall({
      url: "/work-order/execution/list",
      method: "get",
      params,
    }),
  workExecutionById: (workExeBatchId: any) =>
    makeApiCall({
      url: `/work-order/execution/id/${workExeBatchId}`,
      method: "get",
    }),
  createWorkExecution: (data: any) =>
    makeApiCall({
      url: "/work-order/execution/submit-update",
      method: "post",
      data,
    }),
  approveWorkExecution: (data: any) =>
    makeApiCall({
      url: "/work-order/execution/approve",
      method: "post",
      data,
    }),
  rejectWorkExecution: (data: any) =>
    makeApiCall({
      url: "/work-order/execution/reject",
      method: "post",
      data,
    }),
  listWorkExecution: (params: any) =>
    makeApiCall({
      url: "/work-order/list",
      method: "get",
      params,
    }),
};

export default workExecutionApis;
